module.exports = __webpack_public_path__ + "static/media/game_over.f8f082f3.mp3";